import Vue from "vue";

const TikTok = {
  enable() {
    Vue.$log.info("tik tok enable");
    // eslint-disable-next-line no-unused-expressions,wrap-iife
    !(function(w, d, t) {
      w.TiktokAnalyticsObject = t;
      let ttq = (w[t] = w[t] || []);
      const methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie"
      ];
      ttq.methods = methods;
      ttq.setAndDefer = function(t, e) {
        t[e] = function() {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (let method of ttq.methods) ttq.setAndDefer(ttq, method);
      ttq.instance = function(t) {
        const e = ttq._i[t] || [];
        for (let method of ttq.methods) ttq.setAndDefer(e, method);
        return e;
      };
      ttq.load = function(e, n) {
        const i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        n = document.createElement("script");
        n.type = "text/javascript";
        n.async = !0;
        n.src = i + "?sdkid=" + e + "&lib=" + t;
        e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(n, e);
      };

      ttq.load("D2OUPBRC77U8AD2FNHI0");
      ttq.page();
    })(window, document, "ttq");
  },
  wait() {
    return !!window.ttq;
  },

  /**
   * Oferta Nomina
   */
  // Landing
  consulta() {
    window.ttq.track("Landing_Nominas", {
      contents: [
        {
          content_type: "product",
          content_name: "Landing_Nominas"
        }
      ]
    });
  },
  // Oferta
  oferta() {
    window.ttq.track("ViewContent", {
      contents: [
        {
          content_type: "product",
          content_name: "Oferta Nominas"
        }
      ]
    });
  },

  /**
   * Pasos del Camino 1 - Caja de Ahorro
   */
  // TYP
  graciasCajaAhorro() {
    window.ttq.track("Purchase", {
      contents: [
        {
          content_type: "product",
          content_name: "Thank You Nominas"
        }
      ]
    });
  },

  /**
   * Pasos del Camino 2 - Paquetes
   */
  paso1() {
    window.ttq.track("Paso 1_Nominas Paquete", {
      contents: [
        {
          content_type: "product",
          content_name: "Datos Personales"
        }
      ]
    });
  },
  paso2() {
    window.ttq.track("Paso 2_Nominas Paquete", {
      contents: [
        {
          content_type: "product",
          content_name: "Datos Laborales"
        }
      ]
    });
  },
  paso3() {
    window.ttq.track("Paso 3_Nominas Paquete", {
      contents: [
        {
          content_type: "product",
          content_name: "Info Adicional"
        }
      ]
    });
  },
  paso4() {
    window.ttq.track("Paso 4_Nominas Paquete", {
      contents: [
        {
          content_type: "product",
          content_name: "Entrega"
        }
      ]
    });
  },
  // TYP
  thank() {
    window.ttq.track("Purchase", {
      contents: [
        {
          content_type: "product",
          content_name: "Thank You Nominas"
        }
      ]
    });
  },

  /**
   * Pasos del Camino 3 - Cliente
   */
  cliente() {
    window.ttq.track("Purchase", {
      contents: [
        {
          content_type: "product",
          content_name: "Thank You Nominas"
        }
      ]
    });
  },

  /**
   * Pasos del Camino 4 - No Cliente
   */
  noCliente() {
    window.ttq.track("Purchase", {
      contents: [
        {
          content_type: "product",
          content_name: "Thank You Nominas"
        }
      ]
    });
  }
};

export default TikTok;
